<template>
  <div>
    <div v-if="ativar_tab != 1" class="d-flex py-1 px-2 bg-gray-100">
      <v-icon small left>mdi-format-list-bulleted</v-icon>
      <p class="ma-0 font-13">Listagem de pedidos de compra</p>
    </div>

    <v-tabs centered v-model="ativar_tab">
      <v-tab>
        <v-icon left>mdi-clipboard-list-outline</v-icon>
        Pedidos
      </v-tab>
      <v-tab v-if="pedido_selecionado.idpedido">
        <v-icon left>mdi-format-list-bulleted-square</v-icon>
        Itens do Pedido
      </v-tab>

      <v-tab-item  class="ma-0">
        <v-card flat>
          <v-card-text class="pa-0">
            <lista-pedido @update:pedido_selecionado="pedido => (pedido_selecionado = pedido)" @getItens="getItens = $event"></lista-pedido>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item  class="ma-0">
        <div class="d-flex px-1">
          <div class="w-54-porcento">
            <itens-pedido
              :pedido_selecionado="pedido_selecionado"
              :getItens="getItens"
              class="elevation-1 mr-2"
              @update:produto_selecionado="produto => (produto_selecionado = produto)"
            />
          </div>

          <div class="w-46-porcento pl-2 elevation-1 br-3px pt-1px" v-if="produto_selecionado.idproduto">
            <p
              class="ma-0 font-16 font-weight-medium text-truncate"
              v-text="`${produto_selecionado.idproduto} - ${Helpers.primeiraLetraMaiuscula(produto_selecionado.descricao_produto)}`"
            />

            <div>
              <TabelaDetalhesProdutos :produto="PRODUTO_FORMATO_PROP.tabela" />

              <v-divider class="mt-1" />

              <div class="ml-n3 mt-n3" style="height: calc(100vh - 425px)">
                <GraficoMovimentacoesEstoqueProduto :produto="PRODUTO_FORMATO_PROP.grafico" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import ListaPedido from './ListaPedido';
import ItensPedido from './ItensPedido';
import TabelaDetalhesProdutos from "@/components/produto/detalhes/TabelaDetalhesProdutos";
import GraficoMovimentacoesEstoqueProduto from "@/components/produto/detalhes/grafico/GraficoMovimentacoesEstoqueProduto";

export default {
  name: "pedido",
  components: {
    ListaPedido,
    ItensPedido,
    TabelaDetalhesProdutos,
    GraficoMovimentacoesEstoqueProduto
  },
  data: () => ({
    ativar_tab: 0,
    pedido_selecionado: {},
    getItens: 0,
    produto_selecionado: {}
  }),
  computed: {
    PRODUTO_FORMATO_PROP() {
      return {
        tabela: {
          id_grupo: this.produto_selecionado.grupo,
          id_filial: this.produto_selecionado.filial || 9999,
          id_produto: this.produto_selecionado.idproduto,
          produto_eh_combinacao: this.produto_selecionado.produto_eh_combinacao,
        },
        grafico: {
          grupo: this.produto_selecionado.grupo,
          filial: this.produto_selecionado.filial || 9999,
          produto: this.produto_selecionado.idproduto,
          produto_eh_combinacao: this.produto_selecionado.produto_eh_combinacao ? 'S' : 'N',
        }
      }
    },
  },
  watch:{
    getItens(){
      this.ativar_tab = 1;
    }
  }
}
</script>
